import { Box, Container, styled, Typography } from '@mui/material'
import React, { useState } from 'react'
import { SectionTitle } from './LatestProducts'
import img1 from '../assets/images/blogs/blog_01.webp'
import img2 from '../assets/images/blogs/blog_02.jpg'
import img3 from '../assets/images/blogs/blog_03.webp'
import { StyledButton } from './LatestProducts'
import SouthIcon from '@mui/icons-material/South';

const BlogWrapper = styled(props=><Box {...props}>{props.children}</Box>)(({theme})=>({
  display:'flex',
  justifyContent:'center',
  [theme.breakpoints.up('xs')]:{
    flexDirection:'column',
    gap:theme.spacing(5),
  
  },
  [theme.breakpoints.up('sm')]:{
    flexDirection:'row',
    gap:theme.spacing(1),
  
  },
  [theme.breakpoints.up('md')]:{
    flexDirection:'row',
    gap:theme.spacing(1),
  
  },
  [theme.breakpoints.up('lg')]:{
    flexDirection:'row',
    gap:theme.spacing(1),
  
  },
  
}))
const BlogTitle = styled(props=><Typography variant='Body1' {...props}>{props.children}</Typography>)(({theme})=>({
  display:'flex',
  fontFamily:'lato',
  gap:theme.spacing(4),
  cursor:'pointer',
  transition:'0.5s',
  letterSpacing:'0.8px',
  wordSpacing:'2px',
  
  ':hover':{
    color:'#B59677'

  }
}))
const Blog = ({title,author,date,text,img, link})=>{
  const [hover, setHover] = useState(false);
  return(
    <Box onMouseEnter={()=>setHover(true)} onMouseLeave = {()=>setHover(false)} sx={{ display:'flex',flexDirection:'column',width:{xs:'100%',sm:'33.33%',md:'33.33%'},gap:{xs:1,sm:1,md:1,lg:1},p:{xs:1,sm:1,md:2,lg:2} }}>
      <Box sx={{overflow:'hidden', height:'300px',position:'relative' }}>
        <Box sx={{ position:'absolute',zIndex:15,opacity:0.5,width:'0',height:'0',background:'white',top:'50%',left:'50%',transform:'translate(-50%,-50%)',borderRadius:'50%',transition:'all 0.8s',...(hover && {width:'100%',height:'100%',opacity:0}) }}></Box>
        <img src={img} alt = {title} width="100%" height="100%" style={{ objectFit:'cover',transition:'1s',...(hover && {transform:'scale(1.1)'}) }}/>
      </Box>
      <BlogTitle>{title}</BlogTitle>
      <Typography variant="body2">By {author} on {date}</Typography>
      <Typography variant="body2" sx={{ color:'#999999' }}>{text}</Typography>
    </Box>
  )
}
export default function LatestBlog() {
  return (
    <Box sx={{ my:{lg:8,md:6,sm:4,xs:4},background:'#F7F7F7',py:12}}>
    {/* <Container maxWidth> */}
    <Box sx={{ display:'flex',flexDirection:'column' }}>
      <SectionTitle>latest from blog</SectionTitle>
      <BlogWrapper>
      <Blog title="Spring Fashion Trending 2020" author="admin" date="September 23, 2020" text="Typography is the work of typesetters, compositors, typographers, graphic designers, art directors, manga artists, comic..." img={img1}/>
      <Blog title="The Easiest Way to Break Out on Top" author="admin" date="September 23, 2020" text="Typography is the work of typesetters, compositors, typographers, graphic designers, art directors, manga artists, comic..." img={img2}/>
      <Blog title="Fresh your room with white vase" author="admin" date="September 23, 2020" text="Typography is the work of typesetters, compositors, typographers, graphic designers, art directors, manga artists, comic..." img={img3}/>
      </BlogWrapper>
      <StyledButton sx={{ borderRadius:'20px',width:'200px', height:'50px',mt:5 }}>load more posts <SouthIcon fontSize='5px' sx={{marginLeft:1}}/></StyledButton>
    </Box>
    {/* </Container> */}
    </Box>
  )
}
